export default __webpack_public_path__ + "static/media/tweeter-light.3937917c.svg";